module.exports = __webpack_public_path__ + "static/media/cc.15f54a78.png";